import Icon from "@mui/material/Icon";
import AuthService from "services/auth-service";
import "./index.css";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";


const ImageGalleryUpload = ({ images = [], galleryData = [], setGalleryData, handleUpload }) => {
  const [controller] = useMaterialUIController();
  const { sidenavColor, darkMode } = controller;

  const handleDelete = async (id) => {
    try {
      await AuthService.deleteMedia(id);

      // remove do estado sem reload
      setGalleryData(prev => prev.filter(img => img.id !== id));
    } catch (err) {
      console.error("Erro ao excluir imagem", err);
    }
  };

  return (
    <div className="image-gallery-container">
      <div className="image-gallery">

        {/* IMAGENS DO BACKEND */}
        {galleryData.map((img) => (
          <div key={img.id} className="image-item">
            <img src={img.url} alt="gallery" className="image-preview" />
            <div className="image-overlay">
              <Icon
                className="image-overlay-icon"
                onClick={() => handleDelete(img.id)}
              >
                delete
              </Icon>
            </div>
          </div>
        ))}

        {/* PREVIEW LOCAL */}
        {images.map((image, index) => (
          <div key={`local-${index}`} className="image-item">
            <img
              src={URL.createObjectURL(image)}
              alt={`Uploaded ${index}`}
              className="image-preview"
            />
          </div>
        ))}

        {/* UPLOAD */}
        <MDBox
          sx={(theme) => ({
            width: "100px",
            height: "100px",
            minWidth: "100px",
            borderRadius: "0.75rem",
            border: `2px dashed ${darkMode ? "rgba(255,255,255,0.3)" : theme.palette.grey[400]}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            transition: "all 0.2s",
            "&:hover": {
              borderColor: theme.palette[sidenavColor] ? theme.palette[sidenavColor].main : theme.palette.info.main,
              backgroundColor: darkMode ? "rgba(255,255,255,0.05)" : theme.palette.grey[100],
            }
          })}
        >
          <input
            type="file"
            multiple
            onChange={handleUpload}
            className="upload-input"
            id="file-upload"
            style={{ display: "none" }}
          />
          <label htmlFor="file-upload" style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer", margin: 0 }}>
            <Icon fontSize="medium" color={sidenavColor}>add</Icon>
          </label>
        </MDBox>

      </div>
    </div>
  );
};

export default ImageGalleryUpload;
